import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  {
    path: 'auth',
    title: 'Client Auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'home',
    title: 'Home',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'reseller',
    title: 'Reseller Dashboard',
    loadChildren: () => import('./reseller/reseller.module').then((m) => m.ResellerModule),
  },
  {
    path: 'setup',
    title: 'Account Setup',
    loadChildren: () =>
      import('./onboarding/onboarding.module').then((m) => m.ClientOnboardingModule),
  },
  { path: '**', redirectTo: 'auth/notfound', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
